import type { IconData } from '@stacksjs/iconify-core'

export const chevronUpRight: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M8 2H1a1 1 0 1 1 0-2h8a1 1 0 0 1 1 1v8a1 1 0 1 1-2 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default chevronUpRight
